<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 会员管理
      </div>
      <div class="contentLeft">
        <div class="con">
          <!-- 搜索栏 -->
          <div class="toolbar">
            <el-select v-model="query.role" placeholder="全部角色" clearable style="width: 140px; margin-right: 10px;" @change="handleSearch">
              <el-option label="城市代理" :value="1"></el-option>
              <el-option label="区县代理" :value="2"></el-option>
              <el-option label="经销商" :value="3"></el-option>
              <el-option label="个人会员" :value="4"></el-option>
            </el-select>
            <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 120px; margin-right: 10px;" @change="handleSearch">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </div>

          <!-- 会员表格 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="ID" prop="id" width="60"></el-table-column>
              <el-table-column align="center" label="姓名" prop="userName" width="100">
                <template #default="{ row }">{{ row.userName || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="手机号" prop="phone" width="130"></el-table-column>
              <el-table-column align="center" label="角色" prop="roleName" width="100">
                <template #default="{ row }">
                  <el-tag :type="roleTagType(row.role)" size="small">{{ row.roleName }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="邀请码" prop="inviteCode" width="100"></el-table-column>
              <el-table-column align="center" label="城市" prop="cityName" width="100">
                <template #default="{ row }">{{ row.cityName || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="余额" prop="balance" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.balance) }}</template>
              </el-table-column>
              <el-table-column align="center" label="累计收入" prop="totalIncome" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.totalIncome) }}</template>
              </el-table-column>
              <el-table-column align="center" label="可转让额" prop="transferable" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.transferable) }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="80">
                <template #default="{ row }">
                  <span :style="{ color: row.status === 1 ? '#67c23a' : '#f56c6c' }">
                    {{ row.status === 1 ? '启用' : '禁用' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="注册时间" prop="createTime" width="160"></el-table-column>
              <el-table-column align="center" label="操作" width="170">
                <template #default="{ row }">
                  <span class="act act-view" @click="viewDetail(row)">详情</span>
                  <span class="act" :class="row.status === 1 ? 'act-disable' : 'act-enable'" @click="toggleStatus(row)">
                    {{ row.status === 1 ? '禁用' : '启用' }}
                  </span>
                  <span class="act act-del" @click="deleteMember(row)">删除</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.pageNum"
                :page-size="query.pageSize"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 会员详情弹窗 -->
    <el-dialog title="会员详情" v-model="detailVisible" width="600px" class="member-detail-dialog">
      <div v-if="detailData" v-loading="detailLoading">
        <div class="section-title">基础信息</div>
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="ID">{{ detailData.member.id }}</el-descriptions-item>
          <el-descriptions-item label="姓名">{{ detailData.member.userName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detailData.member.phone }}</el-descriptions-item>
          <el-descriptions-item label="角色">
            <el-tag size="small" :type="roleTagType2(detailData.member.roleName)">{{ detailData.member.roleName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="邀请码">{{ detailData.member.inviteCode }}</el-descriptions-item>
          <el-descriptions-item label="城市">{{ detailData.member.cityName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag size="small" :type="detailData.member.status === 1 ? 'success' : 'danger'">
              {{ detailData.member.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="注册时间">{{ detailData.member.createTime }}</el-descriptions-item>
        </el-descriptions>

        <div v-if="detailData.account" class="detail-section">
          <div class="section-title">账户信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="可用余额">¥{{ formatPrice(detailData.account.balance) }}</el-descriptions-item>
            <el-descriptions-item label="冻结余额">¥{{ formatPrice(detailData.account.frozenBalance) }}</el-descriptions-item>
            <el-descriptions-item label="累计收入">¥{{ formatPrice(detailData.account.totalIncome) }}</el-descriptions-item>
            <el-descriptions-item label="累计提现">¥{{ formatPrice(detailData.account.totalWithdrawn) }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 推荐关系（referrer_id，区别于团队层级 parent_id） -->
        <div class="detail-section" v-loading="referralLoading">
          <div class="section-title">推荐关系</div>
          <el-descriptions :column="1" border size="small" style="margin-bottom: 10px;">
            <el-descriptions-item label="推荐人">
              <template v-if="referralData && referralData.referrer">
                {{ referralData.referrer.userName || '-' }}（{{ referralData.referrer.phone || '-' }}）
                <el-tag size="small" style="margin-left: 6px;">{{ referralData.referrer.roleName }}</el-tag>
                <span style="color: #999; margin-left: 6px;">邀请码 {{ referralData.referrer.inviteCode }}</span>
              </template>
              <span v-else style="color: #999;">无（非推荐注册）</span>
            </el-descriptions-item>
          </el-descriptions>
          <div style="font-size: 13px; color: #333; margin-bottom: 6px;">
            被推荐人（{{ referralData ? referralData.refereeCount : 0 }}）
          </div>
          <el-table
            v-if="referralData && referralData.referees && referralData.referees.length"
            :data="referralData.referees"
            size="small"
            :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
            style="width: 100%"
          >
            <el-table-column align="center" label="姓名" width="100">
              <template #default="{ row }">{{ row.userName || '-' }}</template>
            </el-table-column>
            <el-table-column align="center" label="手机号" prop="phone" width="130"></el-table-column>
            <el-table-column align="center" label="角色" width="90">
              <template #default="{ row }"><el-tag size="small" :type="roleTagType2(row.roleName)">{{ row.roleName }}</el-tag></template>
            </el-table-column>
            <el-table-column align="center" label="邀请码" prop="inviteCode" width="100"></el-table-column>
            <el-table-column align="center" label="城市">
              <template #default="{ row }">{{ row.cityName || '-' }}</template>
            </el-table-column>
            <el-table-column align="center" label="注册时间" prop="createTime" width="160"></el-table-column>
          </el-table>
          <div v-else style="color: #999; font-size: 13px;">暂无被推荐人</div>
        </div>
      </div>
    </el-dialog>

    <!-- 删除会员确认弹窗 -->
    <el-dialog title="删除会员" v-model="deleteVisible" width="460px" class="delete-member-dialog">
      <div v-if="deleteTarget" class="del-confirm">
        <div class="dialog-banner banner-warning">
          <span class="banner-icon">⚠</span>
          <span>此操作将<b>永久删除</b>该会员及其商城业务数据，不可在界面恢复（系统会自动整行备份用于回滚）。</span>
        </div>
        <el-descriptions :column="1" border size="small" class="del-info">
          <el-descriptions-item label="姓名">{{ deleteTarget.userName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ deleteTarget.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="角色">{{ deleteTarget.roleName }}</el-descriptions-item>
          <el-descriptions-item label="当前余额">¥{{ formatPrice(deleteTarget.balance) }}</el-descriptions-item>
        </el-descriptions>
        <ul class="del-scope">
          <li class="del-remove">将删除：订单、账户余额、收支流水、收货地址、充值记录</li>
          <li class="del-keep">上级已得佣金不追回</li>
          <li class="del-keep">删除后，该手机号可重新注册为新会员</li>
        </ul>
        <el-input
          v-model="deleteReason"
          type="textarea"
          :rows="2"
          maxlength="200"
          show-word-limit
          placeholder="删除原因（选填）"
          class="del-reason"
        />
      </div>
      <template #footer>
        <el-button @click="deleteVisible = false">取消</el-button>
        <el-button type="danger" :loading="deleteLoading" @click="confirmDelete">确定删除</el-button>
      </template>
    </el-dialog>

    <!-- 启用/禁用确认弹窗 -->
    <el-dialog
      :title="statusTarget && statusTarget.status === 1 ? '禁用会员' : '启用会员'"
      v-model="statusVisible"
      width="440px"
      class="member-action-dialog"
    >
      <div v-if="statusTarget" class="status-confirm">
        <div class="dialog-banner" :class="statusTarget.status === 1 ? 'banner-warning' : 'banner-success'">
          <span class="banner-icon">{{ statusTarget.status === 1 ? '⚠' : '✓' }}</span>
          <span v-if="statusTarget.status === 1">禁用后该会员将<b>无法登录</b>，账户余额冻结（禁止提现 / 转让），名下层级佣金自动转入平台账户。</span>
          <span v-else>启用后该会员将<b>恢复登录</b>、提现 / 转让，名下层级佣金恢复正常归集。</span>
        </div>
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="姓名">{{ statusTarget.userName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ statusTarget.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="角色">{{ statusTarget.roleName }}</el-descriptions-item>
          <el-descriptions-item label="当前状态">
            <el-tag size="small" :type="statusTarget.status === 1 ? 'success' : 'danger'">
              {{ statusTarget.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <template #footer>
        <el-button @click="statusVisible = false">取消</el-button>
        <el-button
          :type="statusTarget && statusTarget.status === 1 ? 'warning' : 'success'"
          :loading="statusLoading"
          @click="confirmToggleStatus"
        >
          {{ statusTarget && statusTarget.status === 1 ? '确定禁用' : '确定启用' }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10,
        role: null,
        status: null,
      },
      detailVisible: false,
      detailLoading: false,
      detailData: null,
      referralLoading: false,
      referralData: null,
      deleteVisible: false,
      deleteTarget: null,
      deleteReason: '',
      deleteLoading: false,
      statusVisible: false,
      statusTarget: null,
      statusLoading: false,
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatPrice(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    roleTagType(role) {
      const map = { 1: 'danger', 2: 'warning', 3: '', 4: 'info' }
      return map[role] || 'info'
    },
    roleTagType2(roleName) {
      const map = { '城市代理': 'danger', '区县代理': 'warning', '经销商': '', '个人会员': 'info' }
      return map[roleName] || 'info'
    },
    handleSearch() {
      this.query.pageNum = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = { ...this.query }
        // 清除空值
        Object.keys(params).forEach(k => { if (params[k] === null || params[k] === '') delete params[k] })
        const res = await axiosconf.applicationJson('/mall/admin/member/list', params)
        if (res.data && res.data.code === 0) {
          const data = res.data.data
          this.tableData = data.records || []
          this.total = data.total || 0
        }
      } catch (e) {
        console.error('获取会员列表失败', e)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.query.pageNum = page
      this.fetchList()
    },
    async viewDetail(row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detailData = null
      this.referralData = null
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/member/detail/${row.id}`)
        if (res.data && res.data.code === 0) {
          this.detailData = res.data.data
        }
      } catch (e) {
        this.$message.error('获取详情失败')
      } finally {
        this.detailLoading = false
      }
      this.fetchReferral(row.id)
    },
    async fetchReferral(memberId) {
      this.referralLoading = true
      try {
        const res = await axiosconf.applicationJsonGet('/mall/admin/member/referral', { memberId })
        if (res.data && res.data.code === 0) {
          this.referralData = res.data.data
        }
      } catch (e) {
        console.error('获取推荐关系失败', e)
      } finally {
        this.referralLoading = false
      }
    },
    toggleStatus(row) {
      this.statusTarget = row
      this.statusVisible = true
    },
    async confirmToggleStatus() {
      if (!this.statusTarget) return
      const newStatus = this.statusTarget.status === 1 ? 0 : 1
      const action = newStatus === 0 ? '禁用' : '启用'
      this.statusLoading = true
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/member/updateStatus/${this.statusTarget.id}`, { status: newStatus })
        if (res.data && res.data.code === 0) {
          this.$message.success(`${action}成功`)
          this.statusVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
        this.statusLoading = false
      }
    },
    deleteMember(row) {
      this.deleteTarget = row
      this.deleteReason = ''
      this.deleteVisible = true
    },
    async confirmDelete() {
      if (!this.deleteTarget) return
      this.deleteLoading = true
      try {
        const res = await axiosconf.applicationJson(
          `/mall/admin/member/delete/${this.deleteTarget.id}`,
          { reason: this.deleteReason || '' }
        )
        if (res.data && res.data.code === 0) {
          this.$message.success('删除成功')
          this.deleteVisible = false
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      } catch (e) {
        this.$message.error('删除失败')
      } finally {
        this.deleteLoading = false
      }
    },
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.toolbar {
  margin-bottom: 16px;
}
.act {
  display: inline-block;
  padding: 0 8px;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  border-right: 1px solid #ebeef5;
  transition: color 0.2s;
}
.act:first-child {
  padding-left: 0;
}
.act:last-child {
  padding-right: 0;
  border-right: none;
}
.act:hover {
  text-decoration: underline;
  font-weight: 600;
}
.act-view {
  color: #679ff6;
}
.act-view:hover {
  color: #337ecc;
}
.act-disable {
  color: #e6a23c;
}
.act-disable:hover {
  color: #b88230;
}
.act-enable {
  color: #67c23a;
}
.act-enable:hover {
  color: #4e962c;
}
.act-del {
  color: #f56c6c;
}
.act-del:hover {
  color: #c45656;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}

/* 弹窗通用提示条 */
.dialog-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.6;
  border-radius: 6px;
}
.dialog-banner .banner-icon {
  font-size: 15px;
  line-height: 1.6;
}
.dialog-banner b {
  font-weight: 700;
}
.banner-warning {
  color: #d48806;
  background: #fff7e6;
  border: 1px solid #ffe7ba;
}
.banner-warning .banner-icon {
  color: #fa8c16;
}
.banner-warning b {
  color: #d4380d;
}
.banner-success {
  color: #389e0d;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
}
.banner-success .banner-icon {
  color: #52c41a;
}
.banner-success b {
  color: #237804;
}

/* 详情弹窗分区标题 */
.section-title {
  position: relative;
  padding-left: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 1px;
  width: 3px;
  height: 14px;
  background: #679ff6;
  border-radius: 2px;
}
.detail-section {
  margin-top: 18px;
}

/* 删除确认弹窗 */
.del-info {
  margin-bottom: 14px;
}
.del-scope {
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
  font-size: 13px;
  line-height: 1.9;
}
.del-scope li {
  position: relative;
  padding-left: 16px;
}
.del-scope li::before {
  content: '';
  position: absolute;
  left: 2px;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.del-scope .del-remove {
  color: #f56c6c;
}
.del-scope .del-remove::before {
  background: #f56c6c;
}
.del-scope .del-keep {
  color: #67c23a;
}
.del-scope .del-keep::before {
  background: #67c23a;
}
</style>

<!-- 弹窗 body 间距：本项目 .el-dialog__body 默认 padding:0，且弹窗 teleport 到 body、scoped :deep 命中不了，故用唯一类名 + 非 scoped 样式 -->
<style>
.delete-member-dialog .el-dialog__body,
.member-action-dialog .el-dialog__body {
  padding: 20px 24px 4px;
}
.member-detail-dialog .el-dialog__body {
  padding: 16px 24px;
}
</style>
